import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(LoadingButton)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  height: 56,
  borderRadius: '999px',
  transition: theme.transitions.create(
    ['background-color', 'box-shadow', 'border-color', 'color'],
    {
      duration: theme.transitions.duration.short,
    }
  ),

  '&.MuiButton-contained': {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },

  '&.MuiLoadingButton-loading': {
    backgroundColor: theme.palette.action.disabledBackground,
  },

  '& .MuiButton-startIcon, & .MuiButton-endIcon': {
    display: 'flex',
    alignItems: 'center',
  },
}));
